import React from 'react';

import { Group, Text, useMantineTheme } from '@mantine/core';

import WorkoutVisibilityIcon from '../WorkoutVisibilityIcon';

interface WeekWorkoutChipProps {
  name: string;
  visibleToAthletes: boolean;
  minHeight: number;
  menu: JSX.Element;
}

const WeekWorkoutChip = ({
  name,
  visibleToAthletes,
  minHeight,
  menu,
}: WeekWorkoutChipProps): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Group
      spacing={4}
      noWrap
      mt={6}
      px={6}
      align='center'
      mih={minHeight}
      sx={{ backgroundColor: theme.fn.rgba(theme.white, 0.75), borderRadius: theme.radius.sm }}
    >
      <Text size='xs' fw={500} lineClamp={1} sx={{ color: theme.colors.dark[9] }}>
        {name}
      </Text>
      <Group spacing={2} noWrap sx={{ marginLeft: 'auto', flexShrink: 0 }}>
        <WorkoutVisibilityIcon visible={visibleToAthletes} withinPortal />
        {menu}
      </Group>
    </Group>
  );
};

export default WeekWorkoutChip;
